var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_lock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Styleguide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input-fileds,-dropdowns,-sliders,-and-other-elements",
    transform: "translate(-470, -544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(70, 516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_lock",
    transform: "translate(400, 28)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "lock",
    mask: "url(#mask-2)",
    fill: "#738089",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2, 0)",
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.98742138,0 C8.17956272,0 9.96226415,1.78270143 9.96226415,3.97484277 L9.96226415,5.98742138 L10.5157233,6.03773585 C11.3200529,6.03773585 11.9748428,6.6923051 11.9748428,7.49685535 L11.9748428,14.5408805 C11.9748428,15.3454307 11.3200529,16 10.5157233,16 L1.4591195,16 C0.654789914,16 0,15.3454307 0,14.5408805 L0,7.49685535 C0,6.6923051 0.654789914,6.03773585 1.4591195,6.03773585 L1.96226415,6.03773585 L2.01257862,3.97484277 C2.01257862,1.78270143 3.79528005,0 5.98742138,0 Z M10.5157233,6.94339623 L1.4591195,6.94339623 C1.15400635,6.94339623 0.905660377,7.19153302 0.905660377,7.49685535 L0.905660377,14.5408805 C0.905660377,14.8462028 1.15400635,15.0943396 1.4591195,15.0943396 L10.5157233,15.0943396 C10.8208364,15.0943396 11.0691824,14.8462028 11.0691824,14.5408805 L11.0691824,7.49685535 C11.0691824,7.19153302 10.8208364,6.94339623 10.5157233,6.94339623 Z M5.98742138,0.905660377 C4.29517787,0.905660377 2.91823899,2.28259926 2.91823899,3.97484277 L2.91823899,5.98742138 L9.00628931,6.03773585 L9.05660377,3.97484277 C9.05660377,2.28259926 7.67966489,0.905660377 5.98742138,0.905660377 Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLock);
export default __webpack_public_path__ + "static/media/ic_lock.c1893ce31e426716d92a71a2bb59f28e.svg";
export { ForwardRef as ReactComponent };